import {
  faHandshakeAlt,
  faTelescope,
} from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ICellRendererParams } from 'ag-grid-community';
import React, { FC, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Avatar, AvatarGroup } from 'components/atoms/avatar';
import { Checkbox as CheckboxAtom } from 'components/atoms/checkbox';
import { EmptyState, EmptyStateContainer } from 'components/atoms/empty-state';
import { Tag } from 'components/atoms/tag';
import { useGetAllActiveUsersMap } from 'hooks/use-idb';
import { fullName } from 'utils/full-name';

export const ParticipantsRenderer: FC<ICellRendererParams> = ({ value }) => {
  const userMap = useGetAllActiveUsersMap();
  const users = useMemo(
    () => (value ?? []).map((id) => userMap[id]).filter(Boolean),
    [userMap, value],
  );

  return value == null ? (
    <>-</>
  ) : (
    <AvatarGroup maxCount={2}>
      {users.map((user) => (
        <Avatar
          key={user.userId}
          name={fullName(user)}
          src={user.imageUrl}
          size="small"
        />
      ))}
    </AvatarGroup>
  );
};
export const MeetingTypeRenderer: FC<ICellRendererParams> = ({ value }) => {
  return value == null ? <>-</> : <Tag {...value}>{value.label}</Tag>;
};
const Checkbox = styled(CheckboxAtom)`
  height: unset;
`;

export const CheckboxRenderer: FC<ICellRendererParams> = ({ node }) => {
  const isSelected = useMemo(() => node.isSelected() ?? false, [node]);
  const changeSelected = useCallback(
    () => node.setSelected(!isSelected),
    [isSelected, node],
  );

  return <Checkbox checked={isSelected} onClick={changeSelected} />;
};
const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: var(--gray-30);
`;

export const MeetingsEmptyState: FC = () => {
  return (
    <EmptyStateContainer>
      <EmptyState
        image={<StyledFontAwesomeIcon icon={faHandshakeAlt} size="4x" />}
        title={<FormattedMessage id="ai_fill.meetings.select.empty.title" />}
        message={
          <FormattedMessage id="ai_fill.meetings.select.empty.description" />
        }
      />
    </EmptyStateContainer>
  );
};

export const MeetingsNoSearchResultState: FC = () => (
  <EmptyState
    image={<StyledFontAwesomeIcon icon={faTelescope} size="4x" />}
    title={
      <FormattedMessage id="ai_fill.meetings.select.empty.no_search_result.title" />
    }
    message={
      <FormattedMessage id="ai_fill.meetings.select.empty.no_search_result.description" />
    }
  />
);
